// -----------------------------------维保-------------------------------
// 维保方案列表
import request from '@/utils/request'

export function maintenancePlanList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/plan/list',
    method: 'POST',
    data,
  })
}

// 合同模板列表查询接口
export function contractTmpList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/list',
    method: 'POST',
    data,
  })
}
// 启用禁用状态更新接口
export function contractTmpUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/updateState',
    method: 'POST',
    data,
    bizCode: [22050],
  })
}
// 合同模板列表新增接口
export function contractTmpAdd(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/add',
    method: 'POST',
    data,
  })
}
// 合同模板编辑接口
export function contractTmpEdit(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/edit',
    method: 'POST',
    data,
  })
}
// 合同模板动态字段查询接口
export function contractTmpVariables(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/variables',
    method: 'POST',
    data,
  })
}
// 合同模板预览接口
export function contractTmpPreview(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/preview',
    method: 'POST',
    data,
  })
}

// 合同模板预览接口
export function contractTmpFixedContentApi(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/fixedContent',
    method: 'POST',
    data,
  })
}

// 合同模板 AI 识别
export function analysisContractAi(data) {
  return request({
    timeout: 300000,
    url: '/admin/v1/vehicle/contract/template/analysisContractAi',
    method: 'POST',
    data,
  })
}

// 获取合同模板 AI 识别摘要信息
export function getAiAnalysisSummary(data) {
  return request({
    timeout: 300000,
    url: '/admin/v1/vehicle/contract/template/getAiAnalysisSummary',
    method: 'POST',
    data,
  })
}

/** -------------------*违章管理*------------------* */
/* 违章数量统计 */
export function ViolationSummary(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/summary',
    method: 'POST',
    data,
  })
}
/* 违章列表 */
export function ViolationList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/status',
    method: 'POST',
    data,
  })
}
/* 违章配置创建 */
export function configSaveViolationConfig(data) {
  return request({
    url: '/admin/v1/vehicle/config/saveViolationConfig',
    method: 'POST',
    data,
  })
}
// 违章配置读取接口
export function getByType(data) {
  return request({
    url: '/admin/v1/vehicle/config/getByType',
    method: 'POST',
    data,
  })
}
/** ---------------*违章记录*-----------------* */
/* 新增违章 */
export function ViolationAdd(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/add',
    method: 'POST',
    data,
  })
}
// 相关信息查询
export function getOrderOnTime(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/getOrderOnTime',
    method: 'POST',
    data,
  })
}
/* 违章明细 */
export function ViolationDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/detail',
    method: 'POST',
    data,
  })
}
/* 脱敏违章明细 */
export function getViolationDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/detail/sensitive',
    method: 'POST',
    data,
  })
}

/* 违章详情 */
export function getViolationInfo(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/getById',
    method: 'POST',
    data,
  })
}

/* 脱敏违章详情 */
export function getSensitiveViolationInfo(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/getById/sensitive',
    method: 'POST',
    data,
  })
}

/* 违章记录删除 */
export function ViolationsDelte(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/detail/delete',
    method: 'POST',
    data,
  })
}
/* 批量导入违章 */
export function violationExcel(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/entranceExcel',
    method: 'POST',
    data,
  })
}

/** ---------------*车险管理*-----------------* */
/* 车险过期状态统计 */
export function insuranceSummary(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insuranceState/summary',
    method: 'POST',
    data,
  })
}
/* 车险列表 */
export function insuranceList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/list',
    method: 'POST',
    data,
  })
}
// 服务商列表查询接口
export function providerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}
/** ---------------------------*维保*-------------------------* */
/* 维保管理查询列表 */
export function maintenanceList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/list',
    method: 'POST',
    data,
  })
}

/* 脱敏维保管理查询列表 */
export function getMaintenanceList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/list/sensitive',
    method: 'POST',
    data,
  })
}

// 发起维保
export function initiateMaintenance(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/launch',
    method: 'POST',
    data,
  })
}
/* 维保详情列表 */
export function maintenanceDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/detail',
    method: 'POST',
    data,
  })
}
/* 脱敏维保单详情 */
export function getMaintenanceDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/detail/sensitive',
    method: 'POST',
    data,
  })
}
/* 编辑维保 */
export function maintenanceEditSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/v2/edit',
    method: 'POST',
    data,
    signParams: ['id', 'totalAmount', 'customerAmount', 'floatAmount'],
  })
}
/* 根据维保类型查询支付项 */
export function queryByType(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/pay/queryByType',
    method: 'POST',
    data,
  })
}
/** ---------------------------*事故*-------------------------* */
/* 脱敏事故管理查询列表 */
export function getAccidentList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/list/sensitive',
    method: 'POST',
    data,
  })
}

/* 事故管理详情列表 */
export function accidentDestail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/detail',
    method: 'POST',
    data,
  })
}

/* 脱敏事故详情 */
export function getAccidentDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/detail/sensitive',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 收款方查询接口（服务商列表查询接口，1维修厂）
 * @apiUrl
 */
export function getCollectCustomerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}
// 发起结算：确认新增
export function accidentSettlementAddSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/settlement/v2/add',
    method: 'POST',
    data,
    signParams: ['accidentId', 'receivableAmount'],
  })
}
/** ---------------------------*服务商列表*-------------------------* */
// 启用禁用状态更新接口
export function providerUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/updateState',
    method: 'POST',
    data,
  })
}
export function ViolationUpdate(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/updateState',
    method: 'POST',
    data,
  })
}

export function updateDealViolationWay(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/updateDealWay',
    method: 'POST',
    data,
  })
}

/* 新增维保 */
export function maintenanceAddSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/v2/add',
    method: 'POST',
    data,
    signParams: ['totalAmount', 'customerAmount', 'floatAmount'],
  })
}

/* 保单列表 */
export function policyList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/detailList',
    method: 'POST',
    data,
  })
}
/* 保单编辑 */
export function policyEdit(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/edit',
    method: 'POST',
    data,
  })
}
/* 保单新增 */
export function policyAdd(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/add',
    method: 'POST',
    data,
  })
}
/* 保单删除列表 */
export function policyDelte(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/delete',
    method: 'POST',
    data,
  })
}

// --------------------------------import request from '@/utils/request'

// 新增采购订单
export function doPurchaseOrderSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/v2/add',
    method: 'post',
    data,
    signParams: [
      'providerId',
      'purchaseMode',
      'payForm',
      'carTotalNum',
      'carTotalAmount',
      'deposit',
      'manageFee',
      'serviceFee',
      'deptId',
    ],
  })
}

// 采购订单状态统计
export function getTabCount(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/summary',
    method: 'post',
    data,
  })
}
// 采购订单列表查询
export function getPurchaseList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/list',
    method: 'post',
    data,
  })
}
// 采购订单退车结算信息详情
export function getSettlementDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/detail',
    method: 'post',
    data,
  })
}
// 获取采购订单详情
export function getPurchaseDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/detail',
    method: 'post',
    data,
  })
}


// --------------------------采购订单列表---------------------------------
export function getSubOrderList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/list',
    method: 'post',
    data,
  })
}
// 子订单详情--订单信息
export function getSubOrderDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/detail',
    method: 'post',
    data,
  })
}

// 批量退车根据车辆id回显详情
export function getCarDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/detail',
    method: 'post',
    data,
  })
}

// 采购子订单退车核算 --- 提交
export function confirmSettlementSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/v2/submit',
    method: 'post',
    data,
    signParams: [
      'orderId',
      'refundableDepositAmount',
      'refundableRentAmount',
      'needPatchAmount',
      'payDepositAmount',
      'paidDepositAmount',
      'payAmount',
      'paidAmount',
    ],
  })
}

// 个人租赁订单确认并提交财务核算
export function rentConfirmSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/confirmSettlement',
    method: 'POST',
    data,
  })
}

// 采购子订单退车核算 --- 保存
export function saveSettlementSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/v2/save',
    method: 'post',
    data,
    signParams: [
      'orderId',
      'refundableDepositAmount',
      'refundableRentAmount',
      'needPatchAmount',
      'payDepositAmount',
      'paidDepositAmount',
      'payAmount',
      'paidAmount',
    ],
  })
}
// 采购子订单结算应收应退金额计算
export function calculateCarAmount(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/calculate',
    method: 'post',
    data,
  })
}

// 子订单新增车辆
export function purchaseSubAddSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/v2/add',
    method: 'post',
    data,
    signParams: ['purchaseOrderId', 'providerId', 'carList[0].id', 'carList[0].modelId'],
  })
}

// 采购子订单统计
export function purchaseSubSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/summary',
    method: 'post',
    data,
  })
}

// 采购子订单统计
export function purchaseCarAddImport(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/car/import',
    method: 'post',
    data,
  })
}


// 支付计划-查看应收单详情
export function purchaseCloseOrder(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/close',
    method: 'post',
    data,
  })
}


// 订单可退车辆(子订单)列表，目前用于批量退车下拉接口 resourceKey=listReturnableCar
export function returnableCarList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/list',
    method: 'post',
    data,
  })
}


// 采购订单批量退车导入(新增接口) resourceKey=importReturnCar
export function carImportant(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/import',
    method: 'post',
    data,
  })
}


// ---------------------------------------------强收车-------------------------------------------------
// 列表
export function forciblyCloseCarList(data) {
  return request({
    url: '/admin/v1/vehicle/recall/car/order/list',
    method: 'POST',
    data,
  })
}


// 统计
export function forciblyCloseCarStatistics(data) {
  return request({
    url: '/admin/v1/vehicle/recall/car/order/statistics',
    method: 'POST',
    data,
  })
}

// 关闭收车单
export function forciblyCloseCarClose(data) {
  return request({
    url: '/admin/v1/vehicle/recall/car/order/close',
    method: 'POST',
    data,
  })
}

// 根据车牌号或客户姓名查询订单
export function getRentOrderId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/getRentOrderId',
    method: 'POST',
    data,
  })
}

// 获取订单详情，订单维度，包括：个人订单、企业子订单
export function getOrderDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/detail',
    method: 'POST',
    data,
  })
}

// 强收车详情
export function recallDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/recall/car/order/detail',
    method: 'POST',
    data,
  })
}

// 发起强收车
export function recallStart(data = {}) {
  return request({
    url: '/admin/v1/vehicle/recall/car/order/start',
    method: 'POST',
    data,
  })
}

// 出入库详情
export function getOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/details',
    method: 'POST',
    data,
  })
}
// 获取出入库详情提交确认未捕获到的部分信息
export function getTempOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/getStockInfo',
    method: 'POST',
    data,
  })
}

// 编辑出入库记录
export function editOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/update',
    method: 'POST',
    data,
  })
}
// 获取最新的出入库信息
export function stockLogFindLastOne(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/findLastOne',
    method: 'POST',
    data,
  })
}

// 根据任务ID查询任务详情
export function getUploadTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 应付列表查询
 * @apiUrl
 */
export function getPaymentList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/list',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 获取应收管理列表
 * @apiUrl
 */
export function getReceivableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/list',
    method: 'POST',
    data,
  })
}
// 校验应收记录批量调整有无审核中的数据
export function receivableFilterReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/filterReceivable',
    method: 'POST',
    data,
  })
}
// 批量收款新增
export function addRecordReceivableSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/v2/add',
    method: 'post',
    data,
    signParams: ['sourceOrderId', 'sourceOrderType', 'totalAmount'],
  })
}
/**
 * @apiName 批量收款中根据customerId查询账户信息
 * @apiUrl
 */
export function getAccountDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/account/detail',
    method: 'POST',
    data,
  })
}
// 获取应收款项列表
export function getCollectionRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/batchSelect',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 收款单收款方式
 * @apiUrl
 */
export function getCollectionPayMethod(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/type',
    method: 'POST',
    data,
  })
}
// 订单退车结算信息
export function vehiclesettlement(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/settlementInfo',
    method: 'POST',
    data,
  })
}
// 个人租赁保存当前核算方案
export function addSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/addSettlement',
    method: 'POST',
    data,
  })
}

// 查询审批动态详情
export function approvalTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/detail',
    method: 'POST',
    data,
  })
}

// 根据退车交接时间 计算 到退车交接完成时间的应收金额 和 剩余租期的应收金额
export function calculateReceivableAmount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/calculateReceivableAmount',
    method: 'POST',
    data,
  })
}

// 绑车
export function bindCarSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/v2/bindCar',
    method: 'POST',
    data,
    signParams: ['carId', 'orderAccruedPlans[0].totalAmount'],
  })
}

/* 违章记录 */
export function exportViolationDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/detail/export',
    method: 'post',
    data,
  })
}

// 违章账号相关
/**
 * 新建账号
 * https://mock-test.cheweijia.com/project/10282/interface/api/491631
 * @param {*} data 参数对象
 * @param {string} data.account 账号，账密登录时必填
 * @param {string} data.city 城市编码
 * @param {string} data.domain 域名，查询网址
 * @param {string} data.password 密码，账密登录时必填
 * @param {number} data.open 是否开启定时查询 1-是 0-否，新建时默认为0
 * @param {number} data.loginMethod 登录方式 1-账密登录 2-扫码登录
 * @param {number} data.needUdun 是否需要U盾 1-需要 0-不需要，账密登录时必填
 * @returns
 */
export function addViolationAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/account/create',
    method: 'post',
    data,
  })
}

/**
 * 编辑账号
 * https://mock-test.cheweijia.com/project/10282/interface/api/491629
 * @param {*} data 参数对象
 * @param {string} data.id 主键
 * @param {string} data.account 账号，账密登录时必填
 * @param {string} data.city 城市编码
 * @param {string} data.domain 域名，查询网址
 * @param {string} data.password 密码，账密登录时必填
 * @param {number} data.open 是否开启定时查询 1-是 0-否，新建时默认为0
 * @param {number} data.loginMethod 登录方式 1-账密登录 2-扫码登录
 * @param {number} data.needUdun 是否需要U盾 1-需要 0-不需要，账密登录时必填
 * @returns
 */
export function editViolationAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/account/edit',
    method: 'post',
    data,
  })
}

/**
 * 账号列表
 * https://mock-test.cheweijia.com/project/10282/interface/api/491627
 * @param {*} data 参数对象
 * @param {string} data.account 账号
 * @param {string} data.city 城市编码
 * @param {number} data.open 是否开启定时查询 1-是 0-否，新建时默认为0
 * @param {number} data.needUdun 是否需要U盾 1-需要 0-不需要
 * @param {number} data.loginMethod 登录方式 1-账密登录 2-扫码登录
 * @param {number} data.pageNum 页码，从1开始
 * @param {number} data.pageSize
 * @returns
 */
export function violationAccountList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/account/list',
    method: 'post',
    data,
  })
}

/**
 * 更新账号状态
 * https://mock-test.cheweijia.com/project/10282/interface/api/491633
 * @param {*} data 参数对象
 * @param {string} data.id 违章账号对应主键id
 * @param {number} data.state 变更状态值，1-启用，0-停用
 * @returns
 */
export function updateViolationAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/account/updateState',
    method: 'post',
    data,
  })
}

/**
 * 查询违章记录列表
 * https://mock-test.cheweijia.com/project/10282/interface/api/491623
 * @param {*} data 参数对象
 * @param {string} data.account 违章账号
 * @param {number} data.queryState 查询状态，2-查询中，3-查询完成，4-查询失败
 * @param {string} data.beginQueryTime 查询时间段的开始时间,yyyy-MM-DD HH:mm:ss
 * @param {string} data.endQueryTime 查询时间段的结束时间,yyyy-MM-DD HH:mm:ss
 * @param {string} data.cityCode 城市编码
 * @param {number} data.pageNum 页码，从1开始
 * @param {number} data.pageSize
 * @returns
 */
export function violationRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/record/list',
    method: 'post',
    data,
  })
}

/**
 * 手动查询违章
 * https://mock-test.cheweijia.com/project/10282/interface/api/491625
 * @param {*} data 参数对象
 * @param {string} data.account 违章账号
 * @param {string} data.id 违章账号对应主键id
 * @param {string} data.cookie 拿到的cookie值
 * @returns
 */
export function queryViolationAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/account/query',
    method: 'post',
    data,
  })
}

/**
 * 获取122登录二维码
 * https://mock-test.cheweijia.com/project/10282/interface/api/491871
 * @param {Object} data 参数对象
 * @param {string} data.domain 各省112域名
 */
export function getLoginQrCode(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/account/qrcode',
    method: 'post',
    data,
  })
}

/**
 * 查询二维码状态
 * https://mock-test.cheweijia.com/project/10282/interface/api/491873
 * @param {Object} data 参数对象
 * @param {string} data.token token
 */
export function queryQrCodeStatus(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/account/qrcode/status',
    method: 'post',
    data,
    // headers: {
    //   // 轮询的业务状态码及错误不拦截，不弹toast
    //   _che_error_code: [75001, 75100, 75000, 500, 501, 502, 503, 504, 404],
    // },
    bizCode: [75001, 75100, 75000, 500, 501, 502, 503, 504, 404],
  })
}

/**
 * 是否展示违章同显
 */
export function isShowViolationSameDisplay(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/showCheckBox',
    method: 'post',
    data,
  })
}


/**
 * 公户单位列表
 */
export function corporateList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/corporateList',
    method: 'post',
    data,
  })
}

/**
 * 备案合同列表
 */

export function updateContractRemark(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/updateRemark',
    method: 'post',
    data,
  })
}

export function contractList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/list',
    method: 'post',
    data,
  })
}

/**
 * 获取备案合同变更记录
 */
export function getContractChangeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/getContractChangeList',
    method: 'post',
    data,
  })
}

/**
 * 查询司机姓名
 */
export function queryCustomerName(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/queryCustomerName',
    method: 'post',
    data,
  })
}

/**
 * 删除备案合同（仅限非车为家来源）
 */
export function deleteContract(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/delete',
    method: 'post',
    data,
  })
}

/**
 * 作废合同
 */
export function cancelContract(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/invalid',
    method: 'post',
    data,
  })
}

/**
 * 违章查询弹窗提醒
 */
export function violationWarn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/warn',
    method: 'post',
    data,
  })
}
/*
 * 维保订单删除
 * @param {Object} data
 * @param {number} data.id 订单id
 * @returns
 */
export function deleteMaintenanceOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/delete',
    method: 'post',
    data,
  })
}

/*
 * 违章转移申请提交
 */
export function violationTransferApply(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/transferApply',
    method: 'post',
    data,
  })
}

/*
 * 轮询查询使用电子签章签约结果
 */
export function querySignatureResult(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/querySignResultFile',
    method: 'post',
    data,
  })
}

/*
 * 获取合同转移信息(点击违章转移调用)
 */
export function getContractTransferInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/getContractTransferInfo',
    method: 'post',
    data,
  })
}

/*
 * 查询备案周期内违章详情
 */
export function queryViolationInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/queryViolationInfo',
    method: 'post',
    data,
  })
}

/*
 * 获取违章转移文件
 */
export function getViolationTransferFile(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/getStorageTransferFile',
    method: 'post',
    data,
  })
}

/*
 * 使用电子签章前置检查
 */
export function checkTransferSignFile(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/checkTransferSignFile',
    method: 'post',
    data,
    // 20006：E签宝公章未授权，请授权公章后重新获取，20007：E签宝授权非公章，请授权公章后重新获取 ，20008：E签宝公章未启用，请启用后重新获取
    bizCode: [20006, 20007, 20008, 20010],
  })
}

// 查询短信信息
export function getSmsInfo(data) {
  return request({
    url: '/admin/v1/vehicle/car/violation/contract/querySmsInfo',
    method: 'post',
    data,
  })
}
